import { RtColumn, RtColumnDef } from "src/components/ReactiveTable/RtColumn";
import { AbstractRow } from "src/components/ReactiveTable/RtTypes";

import * as styles from "./makeMdmActionColumn.module.less";
import {
  actionColumnCapabilities,
  actionColumnWidth,
  makeRowActionKey,
} from "./mdmConstants";

type MakeMdmActionColumnProps<TRow extends AbstractRow> = Partial<{
  align: RtColumnDef["align"];
  width: RtColumnDef["width"];
  minWidth: RtColumnDef["minWidth"];
  capabilities: RtColumnDef["capabilities"];
  cellClassName: string;
  render: RtColumn<TRow>["render"];
}> & {
  key: string;
};
export const makeMdmActionColumn = <TRow extends AbstractRow>({
  key,
  align = "center",
  width = actionColumnWidth,
  minWidth = actionColumnWidth,
  capabilities = actionColumnCapabilities,
  cellClassName = styles.actionCell,
  render,
}: MakeMdmActionColumnProps<TRow>): RtColumn<TRow> => ({
  key: makeRowActionKey(key),
  title: "",
  width,
  minWidth,
  align,
  capabilities,
  cellClassName,
  render,
});
